// src/mutations/importProducts.js
import { gql } from '@apollo/client';

export const IMPORT_PRODUCTS = gql`
  mutation ImportProducts($file: Upload!) {
    importProducts(input: {file: $file}) {
      message
    }
  }
`;

export const GET_PRODUCT_IMPORT_TEMPLATE = gql`
  query GetProductImportTemplate {
    productImportTemplate
  }
`;